import api from './index';

const BASE = '/bookingDelta';

interface BookingDeltaTotals {
    positive: number;
    negative: number;
}

interface BookingByDate {
    slotDate: string;
    bookings: number;
}

export const getAvailableAndBookedBookings = async ({
    dateFrom,
    dateTo,
    location,
    worktype,
}: {
    dateFrom: string;
    dateTo: string;
    location: number;
    worktype?: number;
}) => {
    const params: Record<string, string | number> = { dateFrom, dateTo, location };
    if ((worktype && worktype > -1) || worktype === 0) {
        params.worktype = worktype;
    }
    return api.get(`${BASE}/availableAndBooked`, { params }).then((res) => res.data);
};

export const createBookingAndBookingDelta = async (data: unknown) => {
    return api.post(`${BASE}/createBookingAndBookingDelta`, { data });
};

export const createBookingsAndBookingDeltas = async (data: unknown) => {
    return api.post(`${BASE}/createBookingsAndBookingDeltas`, { data }).then((res) => res.data);
};

export const getAllAvailableBookingsByDateAndWorktype = async (dateFrom: string, dateTo: string, worktype: number) => {
    return api
        .get(`${BASE}/getAllAvailableBookingsByDateAndWorktype`, { params: { dateFrom, dateTo, worktype } })
        .then((res) => res.data);
};

export const getOldestAndLatestBookedBookingsByDateAndWorktype = async (
    dateFrom: string,
    dateTo: string,
    worktype: number
) => {
    return api
        .get(`${BASE}/getOldestAndLatestBookedBookingsByDateAndWorktype`, { params: { dateFrom, dateTo, worktype } })
        .then((res) => res.data);
};

export const getTotalBookedBookingsByDateRangeAndWorktype = async (
    dateFrom: string,
    dateTo: string,
    worktype: number
): Promise<{ totalBookings: BookingDeltaTotals }> => {
    return api
        .get(`${BASE}/getTotalBookedBookingsByDateRangeAndWorktype`, { params: { dateFrom, dateTo, worktype } })
        .then((res) => res.data);
};

export const getAllBookedBookingsByDateRangeAndWorktype = async (
    dateFrom: string,
    dateTo: string,
    worktype: number
): Promise<BookingByDate[]> => {
    return api
        .get(`${BASE}/getAllBookedBookingsByDateRangeAndWorktype`, { params: { dateFrom, dateTo, worktype } })
        .then((res) => res.data);
};

export const getAllBookingDeltaByBookingId = async (bookingId: number) => {
    return api.get(`${BASE}/getAllBookingDeltaByBookingId`, { params: { bookingId } }).then((res) => res.data);
};

export const getAllBookedBookingsByDateRangeGroupByDateAndLocation = async (dateFrom: string, dateTo: string) => {
    return api
        .get(`${BASE}/getAllBookedBookingsByDateRangeGroupByDateAndLocation`, { params: { dateFrom, dateTo } })
        .then((res) => res.data);
};

export const getSumOfBookedBookingsByDateAndWorktypeGroupByLocation = async (
    dateFrom: string,
    dateTo: string,
    worktype: number,
    bookingsCreatedAt: number
) => {
    return api
        .get(`${BASE}/getSumOfBookedBookingsByDateAndWorktypeGroupByLocation`, {
            params: { dateFrom, dateTo, worktype, bookingsCreatedAt },
        })
        .then((res) => res.data);
};

export const getSumOfAllBookedBookingsByDateRangeWorktypeAndLocation = async (
    dateFrom: string,
    dateTo: string,
    worktype: number,
    location: number,
    bookingsCreatedAt: number
): Promise<BookingDeltaTotals> => {
    return api
        .get(`${BASE}/getSumOfAllBookedBookingsByDateRangeWorktypeAndLocation`, {
            params: { dateFrom, dateTo, worktype, location, bookingsCreatedAt },
        })
        .then((res) => res.data);
};

export const getAllBookedBookingsByDateRangeWorktypeAndLocation = async (
    dateFrom: string,
    dateTo: string,
    worktype: number,
    location: number
): Promise<BookingByDate[]> => {
    return api
        .get(`${BASE}/getAllBookedBookingsByDateRangeWorktypeAndLocation`, {
            params: { dateFrom, dateTo, worktype, location },
        })
        .then((res) => res.data);
};

export const getSumOfBookedBookingsByDateAndLocationGroupByWorktype = async (
    dateFrom: string,
    dateTo: string,
    location: number,
    bookingsCreatedAt: number
) => {
    return api
        .get(`${BASE}/getSumOfBookedBookingsByDateAndLocationGroupByWorktype`, {
            params: { dateFrom, dateTo, location, bookingsCreatedAt },
        })
        .then((res) => res.data);
};
